import { Networks } from "./blockchain";

const AVAX_MAINNET = {
  DAO_ADDRESS: "0xECC486d6FdfeE11A78FACB486C93c6058e0A157e",
  SRUG_ADDRESS: "0xd19ae65115071ff9E55D19550bC44dd03dCc78E7",
  RUG_ADDRESS: "0x942f53a16bf2D1aa650fd456BDbB352A22B7b356",
  DURAG_ADDRESS: "0x098F1F4016Af3D96FFed0Ec778EF1A85aA010B35",
  USDC_ADDRESS: "0xa7d7079b0fead91f3e65f86e8915cb59c1a4c664",
  MIM_ADDRESS: "0x130966628846BFd36ff31a822705796e8cb8C18D",
  DAI_ADDRESS: "0xd586E7F844cEa2F87f50152665BCbc2C279D8d70",
  USDT_ADDRESS: "0xc7198437980c041c805A1EDcbA50c1Ce5db95118",
  USDC_E_ADDRESS: "0xA7D7079b0FEaD91F3e65f86E8915Cb59c1a4C664",
  STAKING_ADDRESS: "0x4aB6874C8a837fe7C467f45e1079b753087f7b21",
  REDEEMING_ADDRESS: "0x4D6bB549586718DD377AF57B6Be082Ac6f6B6Efa",
  STAKING_HELPER_ADDRESS: "0x5cb1e8D56958daD1177083fB500B9F66E894f067",
  RUG_BONDING_CALC_ADDRESS: "0x92c7e16d66ddcc1fdcccbdd2eeb507eed0baecb2",
  FLEXIBLE_BONDING_CALC_ADDRESS: "0x4ff95Cd9e9bB4789F698Ac8C459eE716fbD4E143",
  QI_BONDING_CALC_ADDRESS: "0xa4C77eb54c3152251f8470a1f0D1eB475CcE8D30",
  TREASURY_ADDRESS: "0x42807310d09942385b8dac45375Ad9E20B03911f",
  ZAPIN_ADDRESS: "0xaB2D3F4a9C4E929D7ffF1DFce7BAF0F9532048CA",
  RUG_USDC_LP_JOE: "0x41c26a7d64FD4d62EcBD4338daEf613CA78B1DB0",
  BURN_ADDRESS: "0x000000000000000000000000000000000000dead",
  ZERO_ADDRESS: "0x0000000000000000000000000000000000000000",
};

// Saving Old Addresses - KM 1/9/22
// TREASURY_ADDRESS:"0x2F87A9550f19666cEF5De29c5F613966cf164BE6"

export const getAddresses = (networkID: number) => {
  if (networkID === Networks.AVAX) return AVAX_MAINNET;

  throw Error("Network don't support");
};
